module.exports = __webpack_public_path__ + "img/word_cloud.43657898.png";